import "core-js/modules/es.array.push.js";
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, isRef as _isRef, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-c8d3fd5e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "container"
};
const _hoisted_2 = {
  class: "dialog-footer"
};
import { useVModel } from '@vueuse/core';
import { ref, watch } from 'vue';
import { ElMessage } from 'element-plus';
import { addRole, updateRole } from '@/api/role';
// import SelectSearch from '@/components/SelectSearch'
import DistributePermissionMenu from './PermissionMenu.vue';
// import { getTenantInfo } from '@/api/tenant'

export default {
  __name: 'Role',
  props: {
    // 是否回显数据
    model: {
      type: Object,
      default: null
    },
    modelValue: {
      type: Boolean,
      required: true
    }
  },
  emits: ['update:modelValue', 'refreshData', 'clearModel'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;

    // 表单数据
    const formData = ref({
      name: '',
      // 应用名称
      tenantId: '',
      description: '' // 描述
    });
    const resetForm = () => {
      formData.value = {
        name: '',
        // 应用名称
        tenantId: '',
        description: '' // 描述
      };
    };
    watch(() => props.model, async val => {
      if (val) {
        formData.value = {
          id: val.id,
          ...JSON.parse(JSON.stringify(val))
        };
        // const res = await getTenantInfo(formData.value.tenantId)
        // formData.value.tenantName = res.name
      } else {
        resetForm();
      }
    }, {
      immediate: true
    });
    const emits = __emit;
    const isVisible = useVModel(props);
    const rules = ref({
      name: [{
        required: true,
        message: '不能为空',
        trigger: 'blur'
      }],
      tenantId: [{
        required: true,
        message: '不能为空',
        trigger: 'blur'
      }]
    });

    // 表单元素
    const formEl = ref(null);
    /**
     * 新增事件
     */
    const confirmLoading = ref(false);
    const handleAddNewsRole = async () => {
      if (!formEl.value) return;
      await formEl.value.validate(async (valid, fields) => {
        if (valid) {
          try {
            confirmLoading.value = true;
            if (props.model) {
              const permissionMenuArr = [];
              const permissionArr = [];
              permissionMenu.value.forEach(item => {
                var _item$permissionId;
                permissionMenuArr.push({
                  roleId: props.model.id,
                  menuId: item.id
                });
                if (item.permissionId || (_item$permissionId = item.permissionId) !== null && _item$permissionId !== void 0 && _item$permissionId.includes(',')) {
                  if (item.permissionId.includes(',')) {
                    item.permissionId.split(',').forEach(val => {
                      if (permissionArr.find(v => v.permissionId === val)) return;
                      permissionArr.push({
                        roleId: props.model.id,
                        permissionId: val
                      });
                    });
                  } else {
                    permissionArr.push({
                      roleId: props.model.id,
                      permissionId: item.permissionId
                    });
                  }
                }
              });
              await updateRole({
                ...formData.value,
                sysRoleMenuList: permissionMenuArr,
                sysRolePermissionList: permissionArr
              });
              isVisible.value = false;
            } else {
              const permissionMenuArr = [];
              const permissionArr = [];
              permissionMenu.value.forEach(item => {
                var _item$permissionId2;
                permissionMenuArr.push({
                  menuId: item.id
                });
                if (item.permissionId || (_item$permissionId2 = item.permissionId) !== null && _item$permissionId2 !== void 0 && _item$permissionId2.includes(',')) {
                  if (item.permissionId.includes(',')) {
                    item.permissionId.split(',').forEach(val => {
                      if (permissionArr.find(v => v.permissionId === val)) return;
                      permissionArr.push({
                        permissionId: val
                      });
                    });
                  } else {
                    permissionArr.push({
                      permissionId: item.permissionId
                    });
                  }
                }
              });
              await addRole({
                ...formData.value,
                sysRoleMenuList: permissionMenuArr,
                sysRolePermissionList: permissionArr
              });
              isVisible.value = false;
            }
            emits('refreshData');
            ElMessage({
              type: 'success',
              message: props.model ? '修改成功' : '添加成功'
            });
          } catch (error) {
            console.log('🚀 ~ file: Role.vue:180 ~ awaitformEl.value.validate ~ error:', error);
          } finally {
            confirmLoading.value = false;
          }
        } else {
          ElMessage({
            type: 'error',
            message: '验证失败'
          });
        }
      });
    };
    const permissionMenu = ref([]);
    const handleUpdatePermissionMenu = val => {
      permissionMenu.value = val;
    };
    const closed = () => {
      formEl.value.resetFields();
      resetForm();
      if (props.model) {
        emits('clearModel');
      }
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
        modelValue: _unref(isVisible),
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _isRef(isVisible) ? isVisible.value = $event : null),
        title: __props.model ? '修改角色' : '新增角色',
        onClosed: closed,
        class: "dialog-class",
        "close-on-click-modal": false
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
          onClick: _cache[2] || (_cache[2] = $event => isVisible.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: handleAddNewsRole,
          loading: confirmLoading.value
        }, {
          default: _withCtx(() => [_createTextVNode(" 确认 ")]),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          "label-width": "150px",
          model: formData.value,
          rules: rules.value,
          style: {
            "max-width": "90%"
          },
          ref_key: "formEl",
          ref: formEl
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "角色名称",
            prop: "name"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: formData.value.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => formData.value.name = $event),
              placeholder: "请输入角色名称"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "描述"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              type: "textarea",
              autosize: {
                minRows: 2
              },
              modelValue: formData.value.description,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => formData.value.description = $event),
              placeholder: "请输入角色描述"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "菜单权限"
          }, {
            default: _withCtx(() => {
              var _props$model;
              return [_createVNode(DistributePermissionMenu, {
                onUpdatePermissionMenu: handleUpdatePermissionMenu,
                style: {
                  "width": "100%"
                },
                "role-id": (_props$model = __props.model) === null || _props$model === void 0 ? void 0 : _props$model.id
              }, null, 8, ["role-id"])];
            }),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      }, 8, ["modelValue", "title"])]);
    };
  }
};